import { Redirect } from 'expo-router';

/** ADHA listing lives on authenticated home (`/`). Keep this path as a redirect. */
export default function PropertiesWebListRoute() {
  return <Redirect href="/(auth)/(home)" />;
}
